import { parseItems } from './parsers/items';
import { toError } from './parsers/error';
export function initItems(settings, http) {
  function list(folderId, options) {
    if (!folderId) {
      // Facebook doesn't have files in root folder, so we can omit requesting server and return resolved promise right away
      return Promise.resolve({
        data: []
      });
    }
    options = options || {};
    options.paging = options.paging || {};
    const requestOptions = {
      album_id: folderId,
      limit: options.paging.size || settings.itemsLimit,
      after: options.paging.cursor || null
    };
    return http.get(`${settings.apiUrl}${settings.apiPath}/photos`, requestOptions, {
      withCredentials: true,
      headers: options.headers || {}
    }).then(parseItems).catch(toError);
  }
  return {
    list
  };
}